import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from './crud.service';

export interface SpreaderPayoutMethod {
  id?: string;
  vendedorId: string;
  ssn?: string;
  taxId?: string;
  zelle?: any;
  contaBancaria?: any;
  contaInternacional?: any;
  metodoSelecionado?: 'Zelle' | 'ContaBancaria' | 'ContaInternacional' | string;
}

@Injectable({ providedIn: 'root' })
export class SpreaderPayoutMethodService {
  constructor(private crud: CrudService) {}

  getAll(): Observable<SpreaderPayoutMethod[]> {
    return this.crud.getData('recebimentovendedor') as Observable<SpreaderPayoutMethod[]>;
  }

  getMine(vendedorId: string): Observable<SpreaderPayoutMethod> {
    return this.crud.getData('recebimentovendedor/vendedor', vendedorId) as Observable<SpreaderPayoutMethod>;
  }

  create(method: SpreaderPayoutMethod) {
    return this.crud.postData('recebimentovendedor', '', method);
  }

  update(id: string, method: SpreaderPayoutMethod) {
    return this.crud.putData(`recebimentovendedor/${id}`, method);
  }

  delete(id: string) {
    return this.crud.deleteData('recebimentovendedor', id);
  }
}
